(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  const paymentOrderInput = document.getElementById('KissPaymentOrder');
  const paymentAmountInput = document.getElementById('KissPaymentAmount');
  if (paymentOrderInput && paymentAmountInput) {
    const paymentParams = new URLSearchParams(window.location.search);
    const paymentOrderHint = paymentParams.get('order') || '';
    const paymentAmountHint = paymentParams.get('amount') || '';
    if (!paymentOrderInput.value && /^[#A-Za-z0-9_-]{1,60}$/.test(paymentOrderHint)) paymentOrderInput.value = paymentOrderHint;
    if (!paymentAmountInput.value && /^[0-9]+([.,][0-9]{1,2})?$/.test(paymentAmountHint)) paymentAmountInput.value = paymentAmountHint;
  }

  } catch(e) { console.error(e); }
})();
})();
